import http from 'hub-http/clients/apiClient';
export const getTranscriptSetting = () => {
  return http.get('transcript/v1/setting/transcript');
};